module.exports = __webpack_public_path__ + "static/media/middle-twoedge-4.49ce1487.png";